export default class Services {
  constructor(services) {
    if (services) {
      this.services = services;
      this.sidebarItems = services.querySelectorAll('.service-item');
      this.slides = services.querySelectorAll('.slide');
      this.init();
    }
  }

  init() {
    const observerOptions = {
      root: null, // or a specific scroll container
      rootMargin: '0px',
      threshold: 1, // 100% of the slide is visible
    };

    const observer = new IntersectionObserver(this.onIntersect.bind(this), observerOptions);

    this.slides.forEach((slide) => observer.observe(slide));
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      const slide = entry.target;
      const slideId = slide.getAttribute('data-slide');

      const matchingSidebarItem = this.services.querySelector(`#${slideId}`);

      if (entry.isIntersecting) {
        // Remove active class from all sidebar items
        this.sidebarItems.forEach((item) => item.classList.remove('active'));

        // Add active class to the matching item
        if (matchingSidebarItem) {
          matchingSidebarItem.classList.add('active');
        }
      }
    });
  }
}
